import { ErrorResponse, indentstatusenum, MaterialPreperationStatus, StatusEnum, TransferMethodEnum, TransferStatusEnum, TransferTypeenum, WorkStationTypeEnum } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { getConnection, getManager, In, LessThan, MoreThan } from 'typeorm';
import { StockRepository } from '../grn/repository/stock-repository';
import { Stock } from '../stock/stock.entity';
import { TransferMaterialAdapter } from './adapter/transfer-material-adapter';
import { PackingStockTransferData } from './dto/packing-stock-transfer.model';
import { TransferItemsRepository } from './repositories/transfer-items.repository';
import { TransferRepository } from './repositories/transfer-materail.repository';
import { BomRepository } from 'apps/services/sale-service/src/app/saleorder/repository/bom-calculation.repository'
import { TransferMaterialRequest } from './dto/transfer-material.request';
import { CommonResponse, ItemCategoryReq, ItemRequest, ItemSubCategoryRequest, SizeRequest, UnitTypeEnum } from '@gtpl/shared-models/masters';
import { AllTransferInfo, GetAvailableStockResponse, PackingSTItems, TransferItemsDetails, TransferMaterialInfo } from '@gtpl/shared-models/procurement-management';
import { ItemCategoryService, ItemsService, ItemSubCategoryService, RmRackPositionService, SizesService, UnitcodeService } from '@gtpl/shared-services/masters';
import { TransferIdRequest } from './dto/transfer-id.request';
import { TransferInfo } from './entities/transfer-material.entity';
import appSettings from 'apps/services/config';
import { SaleOrderIdRequest } from '../stock/dto/sale-order-id.request';
import { IndentMaterialFormRepository } from '../indent-form-for-material-preparation/dto/indent-form.repository';
import { IndentItemRepository } from '../indent-form-for-material-preparation/dto/indent-item.repository';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { IndentformService, StockService } from '@gtpl/shared-services/procurement';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { LocationWiseStockLogRepository } from './repositories/location-wise-stock-log.repository';
import { MaterialPreperationRepository } from '../stock/repository/material-preperation-repository';
import { PreapredStock } from '../stock/prepared-stock.entity';
@Injectable()
export class TransferMaterialService {
    constructor(
      private logService:LogsService,

        private repo: TransferRepository,
        private adapter: TransferMaterialAdapter,
        private unitcodeService: UnitcodeService,
        private saleOrderService: SaleOrderService,
        private indentformService: IndentformService,
        private itemCategoryService: ItemCategoryService,
        private itemService: ItemsService,
        private sizeService: SizesService,
        private subCategoryService: ItemSubCategoryService,
        private rmRackPositionService: RmRackPositionService,
        private transferItemsRepository: TransferItemsRepository,
        private locationWiseStockLogRepository: LocationWiseStockLogRepository,
        private stockRepo: StockRepository,
        private stockService: StockService,

    ) { }

    async createTransferMaterial(createData: PackingStockTransferData): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            console.log("createData");
            console.log(createData);

            // generate DC Number for plant
            let dcsCount = await this.repo.count({ where: { fromPlant: createData.fromPlant } });
            dcsCount += 1;

            const today = new Date();
            const CurrentYear = today.getFullYear();
            const CurrentMonth = today.getMonth();

            // get form plant name 
            const plantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: createData.fromPlant });
            const fromPlant = plantDetails.status ? plantDetails.data.unitcodeName : "";

            const toPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: createData.toPlant });
            const toPlant = toPlantDetails.status ? toPlantDetails.data.unitcodeName : "";

            let refNo = dcsCount + "";
            while (refNo.length < 4) refNo = "0" + refNo;
            createData.dcNumber = "DC/" + fromPlant.toLocaleUpperCase() + "-" + toPlant.toLocaleUpperCase() + "/" + (CurrentYear.toString().substr(-2)) + "/" + refNo;

            // convert dto to entity 
            const convertedEntity = await this.adapter.convertDtoToEntity(createData);
            console.log("convertedEntity");
            console.log(convertedEntity);
            await manager.startTransaction();
            // save the converted entity 
            const saveResponse = await manager.getCustomRepository(TransferRepository).save(convertedEntity);
            // const savedTransferData: PackingStockTransferData = this.adapter.convertEntityToDto(saveResponse,createData);
            // console.log("savedTransferData");
            // console.log(savedTransferData);

            let flag = true;
            let extflag = true;
            let bomStatusFlag = new Set<boolean>()
            let locationFlag = true;
            console.log("saveResponse");
            console.log(saveResponse);
            if (saveResponse) {
                console.log("createData createData createData");
                console.log(createData);

                if (createData.transferMethod === TransferMethodEnum['Plant To Plant'] && createData.isPreparedMaterial === 'no') {
                    console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
                    for (const item of createData.stockTransferItems) {
                        let ipStockQty = 0;
                        let opStockQty = 0;
                        let stockId = 0;
                        for (const locItem of item.locationStockInfo) {
                            console.log("item");
                            console.log(item);
                            // get available stock
                            let availableStock;
                            let availableStockInLoc;
                                availableStock = await this.stockRepo.createQueryBuilder('stock')
                                .select("SUM(stock.physicalQuantity) AS physicalQuantity, stock.location_id AS location")
                                .where(`stock.stock_id = ` + locItem.stockId)
                                .getRawOne();
                                console.log(availableStock);
                                availableStockInLoc = await this.stockRepo.createQueryBuilder('stock')
                                .select("SUM(stock.physicalQuantity) AS physicalQuantity, SUM(stock.intransitQuantity) AS intransitQuantity, stock.location_id AS location")
                                .where(`stock.location_id = ` + availableStock.location)
                                .getRawOne();
                                ipStockQty = Number(ipStockQty) + Number(availableStock.physicalQuantity);
                                opStockQty = Number(opStockQty) + Number(availableStock.physicalQuantity - locItem.issuedQty);

                                let remainingStock = Number(availableStockInLoc.physicalQuantity) - Number(locItem.issuedQty);
                                if(remainingStock <= 0 && availableStockInLoc.intransitQuantity <= 0){
                                    locationFlag = true;
                                }
                                else{
                                    locationFlag = false;
                                }
                        
                            console.log("availableStock");
                            console.log(availableStock);
                            console.log(locationFlag)

                            if ((availableStock.physicalQuantity - locItem.issuedQty) >= 0) {
                                let updateStock;
                                let availableSkToPlant;
                                if (saveResponse.saleOrderId) {
                                    // update transferred stock
                                    updateStock = await manager.getCustomRepository(StockRepository).update({stockId:locItem.stockId}, { physicalQuantity: () => `physical_quantity-${locItem.issuedQty}` });
                                    //create or update Stock for to plant
                                    // availableSkToPlant = await manager.getCustomRepository(StockRepository).findOne({ where: { itemCategoryId: item.itemCategoryId, itemSubCategoryId: item.itemSubCategoryId, itemId: item.itemId, unitId: createData.toPlant, saleOrderId: saveResponse.saleOrderId } });
                                    let savedStockEntity: any = true;

                                    // if (availableSkToPlant) {
                                    //     // update stock
                                    //     const updateToStock = await manager.getCustomRepository(StockRepository).update({stockId:locItem.stockId}, { intransitQuantity: () => `intransit_quantity+${locItem.issuedQty}`, updatedUser: createData.createdUser });
                                    //     if (!updateToStock.affected) {
                                    //         flag = false;
                                    //         break;
                                    //     }


                                    // }

                                    // else {
                                        // create Stock
                                        // const stockEntity = new Stock();
                                        // stockEntity.saleOrderId = saveResponse.saleOrderId;
                                        // stockEntity.itemId = item.itemId;
                                        // stockEntity.unitId = createData.toPlant;
                                        // stockEntity.locationId = 0;
                                        // stockEntity.itemCategoryId = item.itemCategoryId;
                                        // stockEntity.itemSubCategoryId = item.itemSubCategoryId;
                                        // // stockEntity.sizeId = item.sizeId;
                                        // stockEntity.physicalQuantity = 0;
                                        // stockEntity.intransitQuantity = locItem.issuedQty;
                                        // stockEntity.unitPrice = 0;
                                        // stockEntity.createdUser = createData.createdUser;
                                        // savedStockEntity = await manager.getCustomRepository(StockRepository).save(stockEntity);
                                        // console.log(savedStockEntity);
                                        // if (savedStockEntity.stockId === 0) {
                                        //     flag = false;
                                        //     break;
                                        // }
                                        // else{
                                        //     stockId = stockId + savedStockEntity.stockId;
                                        // }
                                    // }

                                    // const getBomDetails = await manager.getCustomRepository(BomRepository).findOne({ where: { itemId: item.itemId, itemCategoryId: item.itemCategoryId, itemSubCategoryId: item.itemSubCategoryId,saleOrderId:saveResponse.saleOrderId } })
                                    // if (getBomDetails.requiredQuantity - locItem.issuedQty > 0) {
                                    //     bomStatusFlag.add(false)
                                    // }else{
                                    //     bomStatusFlag.add(true)
                                    // }
                                    // let updateBom
                                    // if (!(bomStatusFlag.has(false))) {
                                    //     updateBom = await manager.getCustomRepository(BomRepository).update({ saleOrderId: saveResponse.saleOrderId, itemId: item.itemId, itemCategoryId: item.itemCategoryId, itemSubCategoryId: item.itemSubCategoryId }, { AssignedQuantity: () => `AssignedQuantity+${locItem.issuedQty}`, requiredQuantity: () => `quantity-${locItem.issuedQty}`, status: StatusEnum.CLOSED });
                                    // } else {
                                    //     updateBom = await manager.getCustomRepository(BomRepository).update({ saleOrderId: saveResponse.saleOrderId, itemId: item.itemId, itemCategoryId: item.itemCategoryId, itemSubCategoryId: item.itemSubCategoryId }, { AssignedQuantity: locItem.issuedQty, requiredQuantity: () => `quantity-${locItem.issuedQty}` });
                                    // }
                                    // if (!updateBom) {
                                    //     flag = false;
                                    //     break;
                                    // }
                                } else {
                                    // update transferred stock
                                    if(createData.isPreparedMaterial === 'no'){
                                        updateStock = await manager.getCustomRepository(StockRepository).update({stockId:locItem.stockId}, { physicalQuantity: () => `physical_quantity-${locItem.issuedQty}` });
                                    }
                                    else{
                                        updateStock = await manager.getCustomRepository(StockRepository).update({stockId:locItem.stockId}, { preparedQuantity: () => `prepared_quantity-${locItem.issuedQty}` });
                                    }
                                    
                                    //create or update Stock for to plant
                                    // availableSkToPlant = await manager.getCustomRepository(StockRepository).findOne({ where: { itemCategoryId: item.itemCategoryId, itemSubCategoryId: item.itemSubCategoryId, itemId: item.itemId, unitId: createData.toPlant, saleOrderId: 0 } });
                                    let savedStockEntity:any = true;
                                    // if (availableSkToPlant) {
                                    //     // update stock
                                    //     const updateToStock = await manager.getCustomRepository(StockRepository).update({ itemCategoryId: item.itemCategoryId, itemSubCategoryId: item.itemSubCategoryId, itemId: item.itemId, unitId: createData.toPlant, saleOrderId: 0 }, { intransitQuantity: () => `intransit_quantity+${locItem.issuedQty}`, updatedUser: createData.createdUser });
                                    //     if (!updateToStock.affected) {
                                    //         flag = false;
                                    //         break;
                                    //     }
                                    // } else {
                                        // create Stock
                                        // const stockEntity = new Stock();
                                        // stockEntity.saleOrderId = 0;
                                        // stockEntity.itemId = item.itemId;
                                        // stockEntity.unitId = createData.toPlant;
                                        // stockEntity.locationId = 0;
                                        // stockEntity.itemCategoryId = item.itemCategoryId;
                                        // stockEntity.itemSubCategoryId = item.itemSubCategoryId;
                                        // // stockEntity.sizeId = item.sizeId;
                                        // stockEntity.physicalQuantity = 0;
                                        // stockEntity.intransitQuantity = item.issuedQty;
                                        // stockEntity.unitPrice = 0;
                                        // stockEntity.createdUser = createData.createdUser;
                                        // savedStockEntity = await manager.getCustomRepository(StockRepository).save(stockEntity);
                                        // console.log("savedStockEntity");
                                        // console.log(savedStockEntity);
                                        // if (savedStockEntity.stockId === 0) {
                                        //     flag = false;
                                        //     break;
                                        // }
                                        // else{
                                        //     stockId = stockId + savedStockEntity.stockId;
                                        // }
                                    // }
                                }

                                if(locationFlag && createData.isPreparedMaterial === 'no'){
                                    let updateRackStatus = await this.rmRackPositionService.getReverseLocationAvailability({rmRackPositionId:locItem.locationId})
                                    console.log("updateRackStatus");
                                    console.log(updateRackStatus);
    
                                    if (!updateRackStatus.status) {
                                        flag = false;
                                        break;
                                    }
                                }
                                if (!updateStock.affected) {
                                    flag = false;
                                    break;
                                }
                                
                            } else {
                                throw new ErrorResponse(9999, "Something Went Wrong, Please Verify Stock Again");
                            }
                        }
                        //update ipQty and opQty in items
                        // const updateStItem = await manager.getCustomRepository(TransferItemsRepository).update({ packingStockTransferId: (saveResponse.stockTransferItems).find((rec) => rec.itemId === item.itemId).packingStockTransferId }, { ipQty: ipStockQty, opQty: (ipStockQty - item.issuedQty),receiveStockIds: stockId });
                        // if (!updateStItem.affected) {
                        //     flag = false;
                        //     break;
                        // }
                    }
                    if (!flag) {
                        throw new ErrorResponse(9999, "Failed To create Stock Transfer");
                    } else {
                        manager.completeTransaction();
                        return new CommonResponse(true, 1111, 'Transfer Created Successfully');
                    }

                }
                else if (createData.transferMethod == TransferMethodEnum['Plant To Plant'] && createData.isPreparedMaterial === 'yes') {
                    
                    console.log("createData");
                    console.log(createData);

                    for (const item of createData.stockTransferItems) {
                        console.log(item);
                        console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");

                        let ipStockQty = 0;
                        let opStockQty = 0;
                        let receivedQty = 0;
                        let stockId = '';

                        if(item.locationStockInfo.length > 0)
                        {
                            for (const locItem of item.locationStockInfo) 
                            {
                                console.log("item");
                                console.log(item);
                                // get available stock
                                let availableStock;
                                    availableStock = await manager.getCustomRepository(MaterialPreperationRepository).findOne({ where: {preparedStockId:locItem.stockId}});
                                    ipStockQty = Number(ipStockQty) + (Number(availableStock.PreapredStock) - Number(availableStock.consumedQuantity));
                                    opStockQty = Number(opStockQty) + Number(availableStock.PreapredStock - locItem.issuedQty);
                                    receivedQty = Number(receivedQty)+Number(locItem.issuedQty);
                                    console.log("****** receivedQty *************");
                                    console.log(receivedQty);

                                    let remainingStock = (Number(availableStock.PreapredStock) - Number(availableStock.consumedQuantity)) - Number(locItem.issuedQty);
                                        if(remainingStock <= 0){
                                            locationFlag = false;
                                        }
                                        else{
                                            locationFlag = true;
                                        }
                                
                                console.log("availableStock");
                                console.log(availableStock);

                                let updateStock;
                                let availableSkToPlant;
                                let updateLocation;
                                if (saveResponse.dcNumber != undefined) {
                                    updateStock = await manager.getCustomRepository(MaterialPreperationRepository).update({ preparedStockId:locItem.stockId }, { preparedQuantity: () => `prepared_quantity-${locItem.issuedQty}`,transferedQuantity: () => `transfered_quantity + ${locItem.issuedQty}` });
                                    console.log("updateStock");
                                    console.log(updateStock);
                                    let savedStockEntity
                                    // create Stock
                                    // const stockEntity = new Stock();
                                    // stockEntity.saleOrderId = saveResponse.saleOrderId;
                                    // stockEntity.itemId = item.itemId;
                                    // stockEntity.unitId = createData.toPlant;
                                    // stockEntity.locationId = 0;
                                    // stockEntity.itemCategoryId = item.itemCategoryId;
                                    // stockEntity.itemSubCategoryId = item.itemSubCategoryId;
                                    // // stockEntity.sizeId = item.sizeId;
                                    // stockEntity.physicalQuantity = 0;
                                    // stockEntity.intransitQuantity = locItem.issuedQty;
                                    // stockEntity.unitPrice = 0;
                                    // stockEntity.createdUser = createData.createdUser;
                                    // savedStockEntity = await manager.getCustomRepository(StockRepository).save(stockEntity);
                                    // if (savedStockEntity.stockId === 0) {
                                    //     flag = false;
                                    //     break;
                                    // }
                                    // else{
                                        if(locItem.stockId != ''){
                                            stockId = stockId + ',' + locItem.stockId
                                        }
                                        else{
                                            stockId = savedStockEntity.stockId
                                        }
                                    // }
                                }
                                if (!updateStock.affected) {
                                    flag = false;
                                    break;
                                }
                                if(locationFlag){
                                    const updatePreparedStockStatus = await manager.getCustomRepository(MaterialPreperationRepository).update({preparedStockId:locItem.stockId},{status:MaterialPreperationStatus.PARTIALLY_CONSUMED});
                                    if (!updatePreparedStockStatus.affected) {
                                    flag = false;
                                    break;
                                    }
                                }
                                else{
                                    const updatePreparedStockStatus = await manager.getCustomRepository(MaterialPreperationRepository).update({preparedStockId:locItem.stockId},{status:MaterialPreperationStatus.CONSUMED});
                                    if (!updatePreparedStockStatus.affected) {
                                        flag = false;
                                        break;
                                        }
                                }
                            }

                            
                            
                            // update ipQty and opQty in items
                            // const updateStItem = await manager.getCustomRepository(TransferItemsRepository).update({ packingStockTransferId: (saveResponse.stockTransferItems).find((rec) => rec.itemId === item.itemId).packingStockTransferId }, { receiveStockIds:stockId });
                            // console.log(updateStItem);

                            // if (!updateStItem.affected) {
                            //     flag = false;
                            //     break;
                            // }
                            
                        }
                    }
                    
                    if (!flag) {
                        await manager.releaseTransaction();
                        throw new ErrorResponse(9999, "Failed To create Stock Transfer");
                    } else {
                        manager.completeTransaction();
                        return new CommonResponse(true, 1111, 'Transfer Created Successfully');
                    }

                }
                else if (createData.transferMethod == TransferMethodEnum['Warehouse To Plant']) {
                    console.log("createData");
                    console.log(createData);

                    let transferflag = true;
                    for (const item of createData.stockTransferItems) {
                        console.log(item);
                        console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");

                        let ipStockQty = 0;
                        let opStockQty = 0;
                        let receivedQty = 0;
                        let stockId = 0;

                        if(item.locationStockInfo.length > 0)
                        {
                            for (const locItem of item.locationStockInfo) 
                            {
                                console.log("item");
                                console.log(item);
                                // get available stock
                                let availableStock;
                                let availableStockInLoc;
                                    // availableStock = await manager.getCustomRepository(StockRepository).findOne({ where: {stockId:locItem.stockId}});
                                    availableStock = await this.stockRepo.createQueryBuilder('stock')
                                    .select("SUM(stock.physicalQuantity) AS physicalQuantity, stock.location_id AS location")
                                    .where(`stock.stock_id = ` + locItem.stockId)
                                    .getRawOne();
                                    console.log(availableStock);
                                    availableStockInLoc = await this.stockRepo.createQueryBuilder('stock')
                                    .select("SUM(stock.physicalQuantity) AS physicalQuantity, SUM(stock.intransitQuantity) AS intransitQuantity, stock.location_id AS location")
                                    .where(`stock.location_id = ` + availableStock.location)
                                    .getRawOne();
                                    ipStockQty = Number(ipStockQty) + Number(availableStock.physicalQuantity);
                                    opStockQty = Number(opStockQty) + Number(availableStock.physicalQuantity - locItem.issuedQty);
                                    receivedQty = Number(receivedQty)+Number(locItem.issuedQty);
                                    console.log("****** receivedQty *************");
                                    console.log(receivedQty);

                                    let remainingStock = Number(availableStockInLoc.physicalQuantity) - Number(locItem.issuedQty);
                                        if(remainingStock <= 0 && availableStockInLoc.intransitQuantity <= 0){
                                            locationFlag = true;
                                        }
                                        else{
                                            locationFlag = false;
                                        }
                                
                                console.log("availableStock");
                                console.log(availableStock);
                                console.log(locationFlag)
                                let updateStock;
                                let availableSkToPlant;
                                let updateLocation;
                                if (saveResponse.dcNumber != undefined) {
                                    updateStock = await manager.getCustomRepository(StockRepository).update({ stockId:locItem.stockId }, { physicalQuantity: () => `physical_quantity-${locItem.issuedQty}` });
                                    console.log("updateStock");
                                    console.log(updateStock);

                                    //create or update Stock for to plant
                                    availableSkToPlant = await manager.getCustomRepository(StockRepository).findOne({ where: { itemCategoryId: item.itemCategoryId, itemSubCategoryId: item.itemSubCategoryId, itemId: item.itemId, unitId: createData.toPlant, saleOrderId: saveResponse.saleOrderId, locationId: 0} });
                                    let savedStockEntity: any = true;
                                    console.log("availableSkToPlant");
                                    console.log(availableSkToPlant);


                                    if (availableSkToPlant) {
                                        // update stock
                                        const updateToStock = await manager.getCustomRepository(StockRepository).update({stockId: availableSkToPlant.stockId}, { intransitQuantity: () => `intransit_quantity+${locItem.issuedQty}`, updatedUser: createData.createdUser });
                                        console.log(updateToStock)
                                        if (!updateToStock.affected) {
                                            console.log("SSSSSTTTTTTOOOOOCCCKKKKKKK")
                                            flag = false;
                                            break;
                                        }
                                    }

                                    else {
                                        // create Stock
                                        const stockEntity = new Stock();
                                        stockEntity.saleOrderId = saveResponse.saleOrderId;
                                        stockEntity.itemId = item.itemId;
                                        stockEntity.unitId = createData.toPlant;
                                        stockEntity.locationId = 0;
                                        stockEntity.itemCategoryId = item.itemCategoryId;
                                        stockEntity.itemSubCategoryId = item.itemSubCategoryId;
                                        // stockEntity.sizeId = item.sizeId;
                                        stockEntity.physicalQuantity = 0;
                                        stockEntity.intransitQuantity = locItem.issuedQty;
                                        stockEntity.unitPrice = 0;
                                        stockEntity.createdUser = createData.createdUser;
                                        savedStockEntity = await manager.getCustomRepository(StockRepository).save(stockEntity);
                                        if (!savedStockEntity) {
                                            console.log("SSSSSTTTTTTOOOOOCCCKKKKKKK EEEENNNTTTRRRYYYYY")
                                            flag = false;
                                            break;
                                        }
                                    }
                                } 
                                
                                if(locationFlag){
                                    let updateRackStatus = await this.rmRackPositionService.getReverseLocationAvailability({rmRackPositionId:availableStock.location})
                                    console.log("updateRackStatus");
                                    console.log(updateRackStatus);

                                    if (!updateRackStatus.status) {
                                        console.log("RRRRRAAAACCCKKKK UUUPPDDDAATTEE")
                                        flag = false;
                                        break;
                                    }
                                }
                                if (!updateStock.affected) {
                                    console.log("SSSSSSSSSTTTTTTTTTTTOOOOOOOOOCCCCCCCCCCKKKKKKKKKKKKKK UUUUUUPPPPPPPDDDDDDDAAAAAATE")
                                    flag = false;
                                    break;
                                }
                            }

                            console.log("Issued Qty " , item.issuedQty , "Required Qty " , item.requiredQty);
                            if(item.issuedQty === item.requiredQty){
                                transferflag = true;
                            }
                            console.log("*********************************************************");
                            console.log(item);
                            console.log("*********************************************************");
                            //update ipQty and opQty in items
                            // const updateStItem = await manager.getCustomRepository(TransferItemsRepository).update({ packingStockTransferId: saveResponse.packingStockTransferId }, { ipQty: ipStockQty, opQty: opStockQty });
                            // console.log(updateStItem);

                            // if (!updateStItem.affected) {
                            //     flag = false;
                            //     break;
                            // }
                            
                        }
                        const updateIndentIssuedQty = await manager.getCustomRepository(IndentItemRepository).update({ indentItemId : item.indentItemId}, { receivedQuantity: () => `received_quantity+${receivedQty}` });
                            console.log("********** updateIndentIssuedQty ***************");
                            console.log(updateIndentIssuedQty);
                            if (!updateIndentIssuedQty.affected) {
                            console.log("IIIIIINNNNNNDDDDDDDDDEEEEEEENNNNNNTTTT IIIIIIITTTTTTTTEEEEEEEEEMMMMMMMMM");
                                flag = false;
                            }
                    }
                    if(!transferflag){
                        const updateIndentStatus = await manager.getCustomRepository(IndentMaterialFormRepository).update({ indentMaterialPreparationId : createData.indentId}, { status: 'IN PROGRESS' });
                        console.log(updateIndentStatus);
                        if (!updateIndentStatus.affected) {
                            console.log("IIIIIINNNNNNDDDDDDDDDEEEEEEENNNNNNTTTT");
                            flag = false;
                        }
                    }
                    else{
                        const updateIndentStatus = await manager.getCustomRepository(IndentMaterialFormRepository).update({ indentMaterialPreparationId : createData.indentId}, { status: 'PARTIALLY TRANSFERRED' });
                        console.log(updateIndentStatus);
                        if (!updateIndentStatus.affected) {
                            console.log("IIIIIINNNNNNDDDDDDDDDEEEEEEENNNNNNTTTT SSSSSSSSSSSSSSSSSSS");
                            flag = false;
                        }
                    }
                    
                    if (!flag) {
                        await manager.releaseTransaction();
                        throw new ErrorResponse(9999, "Failed To create Stock Transfer");
                    } else {
                        manager.completeTransaction();
                        return new CommonResponse(true, 1111, 'Transfer Created Successfully');
                    }

                } else {
                    for (const extItem of saveResponse.stockTransferItems) {
                        let extavailableStock
                        if (saveResponse.saleOrderId) {
                            extavailableStock = await manager.getCustomRepository(StockRepository).findOne({ where: { itemCategoryId: extItem.itemCategoryId, itemSubCategoryId: extItem.itemSubCategoryId, itemId: extItem.itemId, unitId: createData.fromPlant, saleOrderId: 0 } });
                        } else {
                            extavailableStock = await manager.getCustomRepository(StockRepository).findOne({ where: { itemCategoryId: extItem.itemCategoryId, itemSubCategoryId: extItem.itemSubCategoryId, itemId: extItem.itemId, unitId: createData.fromPlant, saleOrderId: 0 } });
                        }
                        if ((extavailableStock.physicalQuantity - extItem.transferredQty) >= 0) {
                            let extupdateStock
                            if (saveResponse.saleOrderId) {
                                // update transferred stock
                                extupdateStock = await manager.getCustomRepository(StockRepository).update({ itemCategoryId: extItem.itemCategoryId, itemSubCategoryId: extItem.itemSubCategoryId, itemId: extItem.itemId, unitId: createData.fromPlant, saleOrderId: 0 }, { physicalQuantity: () => `physical_quantity-${extItem.transferredQty}` });

                            } else {
                                extupdateStock = await manager.getCustomRepository(StockRepository).update({ itemCategoryId: extItem.itemCategoryId, itemSubCategoryId: extItem.itemSubCategoryId, itemId: extItem.itemId, unitId: createData.fromPlant, saleOrderId: 0 }, { physicalQuantity: () => `physical_quantity-${extItem.transferredQty}` });

                            }
                            if (!extupdateStock.affected) {
                                extflag = false
                                break;
                            }
                        } else {
                            throw new ErrorResponse(9999, "Something Went Wrong, Verify Stock Again");
                        }

                    }
                    if (!extflag) {
                        throw new ErrorResponse(9999, "Failed To create External Stock Transfer");
                    } else {
                        manager.completeTransaction();
                        return new CommonResponse(true, 1111, 'Transfered Successfully');
                    }

                }
            } else {
                await manager.releaseTransaction();
                throw new ErrorResponse(9999, "Failed To create Stock Transfer");
            }

        } catch (error) {
            console.log("ServiceError");
            console.log(error);
            await manager.releaseTransaction();
            return error;
        }
    }

    async ReceiveStock(req: TransferIdRequest): Promise<AllTransferInfo> {
        console.log(req);
        const manager = new GenericTransactionManager();
        try {
            const response = await this.repo.createQueryBuilder('transfer_material_data')
                .leftJoinAndSelect("transfer_material_data.stockTransferItems", 'items')
                .where(`transfer_material_data.transfer_id = ` + req.packingStockTransferId)
                .getOne();
                console.log(response);
            if (response) {
                //generate MRN Number
                let MRNCount = await this.repo.count({ where: { toPlant: response.toPlant, status: TransferStatusEnum.RECEIVED } });
                MRNCount += 1;

                const today = new Date();
                const CurrentYear = today.getFullYear();
                const CurrentMonth = today.getMonth();
                let fromDate = 0;
                if (CurrentMonth < 4) {
                    fromDate = (CurrentYear);
                } else {
                    fromDate = (CurrentYear);
                }
                // get form plant name 
                const plantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: response.fromPlant });
                const fromPlant = plantDetails.status ? plantDetails.data.unitcodeName : "";

                const toPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: response.toPlant });
                const toPlant = toPlantDetails.status ? toPlantDetails.data.unitcodeName : "";

                let getBarcode = await this.saleOrderService.getSaleOrderItemDetailsBySoItemId({saleOrderId:response.saleOrderId,saleOrderItemId:response.saleOrderItemId});
                        console.log("*********************************************");
                        console.log(getBarcode);


                let refNo = MRNCount + "";
                while (refNo.length < 4) refNo = "0" + refNo;
                const mrnNumber = "MRN/" + fromPlant.toLocaleUpperCase() + "-" + toPlant.toLocaleUpperCase() + "/" + (fromDate.toString().substr(-2)) + "/" + refNo;
                await manager.startTransaction();

                let msg = '';
                let flag = true;
                if(response.transferMethod === "INTERNAL" && response.isPreparedMaterial === 'no'){
                    console.log(response.transferMethod);
                    for (const item of response.stockTransferItems) {
                        let stockIds = (item.receiveStockIds).length != undefined ? (item.receiveStockIds).split(",").map(Number) : [item.receiveStockIds].map(Number);
                        console.log(stockIds);
                        console.log(item);
                        let updateStock;
                        updateStock = await manager.getCustomRepository(StockRepository).update({ stockId: In (stockIds)}, { physicalQuantity: () => `physical_quantity+intransit_quantity`,intransitQuantity: 0, updatedUser: response.createdUser });
                        console.log('uodate');
                        console.log(updateStock);
                        if (!updateStock.affected) {
                            flag = false
                            msg = 'Failed To Update Received Item';
                            break;
                        }
                    }
                }
                else if(response.transferMethod === "INTERNAL" && response.isPreparedMaterial === 'yes'){
                    console.log(response.transferMethod);
                    let savedStockEntity
                    
                    for (const item of response.stockTransferItems) {
                        
                        let itemCode = await this.stockService.getSOAndSoitemData({itemId:item.itemId,unitId:req.plantId,saleOrderId:response.saleOrderId,locationId:0,saleOrderItemId:response.saleOrderItemId});
                        console.log("itemCode.data");
                        console.log(itemCode.data);

                        let itemCodes = await this.itemService.getItemById({itemId:item.itemId});
                        console.log(itemCode);
                        console.log(itemCodes);

                        const stockEntity = new PreapredStock();
                        stockEntity.saleOrderId = response.saleOrderId;
                        stockEntity.saleOrderItemId = response.saleOrderItemId;
                        stockEntity.itemId = item.itemId;
                        stockEntity.unitId = response.toPlant;
                        stockEntity.barcode = getBarcode.status?getBarcode.data.barcode:"";
                        stockEntity.stockId = 0;
                        stockEntity.preparedQuantity = item.transferredQty;
                        stockEntity.consumedQuantity = 0;
                        stockEntity.stockInQuantity = 0;
                        stockEntity.status = MaterialPreperationStatus.PREPARED;
                        stockEntity.productName = (itemCode.status?itemCode.data[0].productDesc:"")+"/"+(itemCodes.itemName != undefined ?itemCodes.itemName:"");
                        stockEntity.storeIssueId = 0;
                        stockEntity.transferedQuantity = 0;
                        stockEntity.createdUser = req.createdUser;
                        savedStockEntity = await manager.getCustomRepository(MaterialPreperationRepository).save(stockEntity);
                        if (!savedStockEntity) {
                            flag = false;
                            break;
                        }
                        const updateIndentStatus = await manager.getCustomRepository(TransferItemsRepository).update({ packingStockTransferId : item.packingStockTransferId}, { receiveStockIds: savedStockEntity.preparedStockId });
                            console.log(updateIndentStatus);
                            if (!updateIndentStatus.affected) {
                                flag = false;
                            }
                        // let stockIds = (item.receiveStockIds).split(",").map(Number)
                        // console.log(stockIds);
                        // console.log(item);
                        // let updateStock;
                        // updateStock = await manager.getCustomRepository(StockRepository).update({ stockId: In (stockIds)}, { preparedQuantity: () => `prepared_quantity+intransit_quantity`,intransitQuantity: 0, updatedUser: response.createdUser });
                        // console.log('uodate');
                        // console.log(updateStock);
                        // if (!updateStock.affected) {
                        //     flag = false
                        //     msg = 'Failed To Update Received Item';
                        //     break;
                        // }
                    }
                }
                else{
                    console.log("response.transferMethod");
                    console.log(response.transferMethod);


                    for (const item of response.stockTransferItems) {
                        //check in - transit stock
                        let availableSkToPlant;
                        if (item.saleOrderId) {
                            availableSkToPlant = await manager.getCustomRepository(StockRepository).findOne({ where: { itemCategoryId: item.itemCategoryId, itemSubCategoryId: item.itemSubCategoryId, itemId: item.itemId, unitId: response.toPlant, saleOrderId: item.saleOrderId, locationId: 0 } });
                        } else {
                            availableSkToPlant = await manager.getCustomRepository(StockRepository).findOne({ where: { itemCategoryId: item.itemCategoryId, itemSubCategoryId: item.itemSubCategoryId, itemId: item.itemId, unitId: response.toPlant, saleOrderId: 0 } });
                        }
                        console.log("&&&&&&&&&&&&&&&&&&")
                        console.log(availableSkToPlant.intransitQuantity)
                        console.log(item.transferredQty)

                        // if ((availableSkToPlant.intransitQuantity - item.transferredQty) >= 0) {
                            // update stock
                            let updateStock;
                            if (item.saleOrderId) {
                                updateStock = await manager.getCustomRepository(StockRepository).update({ itemCategoryId: item.itemCategoryId, itemSubCategoryId: item.itemSubCategoryId, itemId: item.itemId, unitId: response.toPlant, saleOrderId: item.saleOrderId, locationId : 0 }, { intransitQuantity: () => `intransit_quantity-${item.transferredQty}`, physicalQuantity: () => `physical_quantity+${item.transferredQty}`, updatedUser: response.createdUser });
                            } else {
                                updateStock = await manager.getCustomRepository(StockRepository).update({ itemCategoryId: item.itemCategoryId, itemSubCategoryId: item.itemSubCategoryId, itemId: item.itemId, unitId: response.toPlant, saleOrderId: 0 }, { intransitQuantity: () => `intransit_quantity-${item.transferredQty}`, physicalQuantity: () => `physical_quantity+Round(${item.transferredQty},0)`, updatedUser: response.createdUser });
                            }


                            if (!updateStock.affected) {
                                flag = false
                                msg = 'Failed To Update Received Item';
                                break;
                            }
                        // } else {
                        //     flag = false;
                        //     msg = 'Quantity Mismatched please check again';
                        //     break;
                        // }
                    }
                }

                const updateSt = await manager.getCustomRepository(TransferRepository).update({ packingStockTransferId: response.packingStockTransferId }, { status: TransferStatusEnum.RECEIVED, mrnNumber: mrnNumber, receivedDate: new Date(), updatedUser: req.createdUser, receivedUser: req.createdUser });
                if (updateSt.affected) {
                    const indentId = await this.repo.findOne({where:{packingStockTransferId: response.packingStockTransferId}});
                    if(indentId.indentId != null){
                        const checkTransferStock = await this.repo.find({where:{indentId: indentId.indentId, status : TransferStatusEnum.IN_TRANSIT}});
                        console.log(checkTransferStock);
                        if((checkTransferStock.length -1) <= 0){
                            const updateIndentStatus = await manager.getCustomRepository(IndentMaterialFormRepository).update({ indentMaterialPreparationId : indentId.indentId}, { status: 'CLOSE' });
                            console.log(updateIndentStatus);
                            if (!updateIndentStatus.affected) {
                                flag = false;
                            }
                        }
                    }
                    
                    if (flag) {
                        await manager.completeTransaction();
                        return new AllTransferInfo(true, 1111, 'Received Successfully');
                    } else {
                        await manager.releaseTransaction();
                        throw new ErrorResponse(9999, msg);
                    }
                } else {
                    await manager.releaseTransaction();
                    throw new ErrorResponse(9999, 'Failed To Receive');
                }
            } else {
                await manager.releaseTransaction();
                throw new ErrorResponse(9999, 'Failed To Receive');
            }

        } catch (error) {
            console.log(error);
            await manager.releaseTransaction();
            return error;
        }
    }

    async getTransferMaterialDCData(req: TransferMaterialRequest): Promise<AllTransferInfo> {
        try {
            // console.log("req" + req.unitId);

            // let response: TransferMaterialInfo[] = await this.repo.createQueryBuilder('transfer_material_data')
            //     .select('transfer_id as packingStockTransferId, from_plant as fromPlant, to_plant as toPlant, transfer_date as transferredDate, note, dc_number as dcNumber, mrn_number as mrnNumber, status')
            //     .where(`is_active=1`);
            //     response = response + ".andWhere(`from_plant = '${UnitTypeEnum.PLANT}'`)";

            //     response = response + ".orderBy(`status`, "ASC").getRawMany()";
            const entityManager = getManager();

            let dataQuery = `SELECT tounit.unit_name AS toPlantName, fromunit.unit_name AS fromPlantName,t.is_prepared_material AS isPreparedMaterial,imp.indent_code AS indent,IF(transfer_method = 'INTERNAL','Plant To Plant', IF(transfer_method = 'EXTERNAL','Plant To Third Party',IF(transfer_method = 'INDENT','Warehouse To Plant',''))) AS transferMethod, transfer_id as packingStockTransferId, from_plant as fromPlant, to_plant as toPlant, transfer_date as transferredDate, note, dc_number as dcNumber, mrn_number as mrnNumber, t.status, indent_id AS indentId FROM ` + appSettings.procure_db + `.transfer_material t left join `+appSettings.procure_db+`.indent_material_preparation imp on imp.indent_material_preparation_id = t.indent_id left join `+appSettings.masters_db+`.unitcodes tounit on tounit.unit_code_id = t.to_plant left join `+appSettings.masters_db+`.unitcodes fromunit on fromunit.unit_code_id = t.from_plant where t.is_active=1`;
            if (req.unitId != 5) {
                dataQuery = dataQuery + ` and t.from_plant=` + req.unitId;
            }
            dataQuery = dataQuery + ` ORDER BY t.status ASC`;
            var response: TransferMaterialInfo[] = await entityManager.query(dataQuery);

            if (response && response.length) {
                // for (const transferInfo of response) {
                //     const plantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: transferInfo.fromPlant });
                //     const fromPlant = plantDetails.status ? plantDetails.data.unitcodeName : "";

                //     const toPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: transferInfo.toPlant });
                //     const toPlant = toPlantDetails.status ? toPlantDetails.data.unitcodeName : "";
                //     transferInfo.fromPlantName = fromPlant;
                //     transferInfo.toPlantName = toPlant;
                // }
                const repo= new AllTransferInfo(true, 1111, 'Dc Information Retrieved Successfully', response);
            //     const newLogDto = new LogsDto(1,'view stock transfer Details', 'TransferItems', 0, true, '','')
            // let res = await this.logService.createLog(newLogDto);
            return repo
             } else {
                return new AllTransferInfo(false, 9999, 'No DC Data Found');
            }
        } catch (error) {
            return error;
        }
    }

    async getTransferMaterialMRNData(req: TransferMaterialRequest): Promise<AllTransferInfo> {
        try {
            // console.log("req" + req.unitId);
            // const response: TransferMaterialInfo[] = await this.repo.createQueryBuilder('transfer_material_data')
            //     .select('transfer_id as packingStockTransferId, from_plant as fromPlant, to_plant as toPlant, transfer_date as transferredDate, note, dc_number as dcNumber, mrn_number as mrnNumber, status')
            //     .andWhere(`to_plant = '${req.unitId}' and is_active=1 and unit_name!='Head Office'`)
            //     .orderBy(`status`, "ASC")
            //     .getRawMany();
            const entityManager = getManager();

            let dataQuery = `SELECT tounit.unit_name AS toPlantName, fromunit.unit_name AS fromPlantName,t.to_plant AS plantId,t.is_prepared_material AS isPreparedMaterial,imp.indent_code AS indent,IF(transfer_method = 'INTERNAL','Plant To Plant', IF(transfer_method = 'EXTERNAL','Plant To Third Party',IF(transfer_method = 'INDENT','Warehouse To Plant',''))) AS transferMethod,t.transfer_id as packingStockTransferId, from_plant as fromPlant, to_plant as toPlant, transfer_date as transferredDate, note, dc_number as dcNumber, mrn_number as mrnNumber, t.status,  indent_id AS indentId, SUM(ti.transferred_quantity) AS issuedQty FROM ` + appSettings.procure_db + `.transfer_material t left join `+appSettings.masters_db+`.unitcodes tounit on tounit.unit_code_id = t.to_plant left join `+appSettings.masters_db+`.unitcodes fromunit on fromunit.unit_code_id = t.from_plant left join `+appSettings.procure_db+`.indent_material_preparation imp on imp.indent_material_preparation_id = t.indent_id left join `+appSettings.procure_db+`.transferred_items ti on ti.transfer_id = t.transfer_id where t.is_active=1`;
            if (req.unitId != 5) {
                dataQuery = dataQuery + ` and t.to_plant=` + req.unitId;
            }
            dataQuery = dataQuery + ` GROUP BY t.transfer_id ORDER BY t.status ASC`;
            var response: TransferMaterialInfo[] = await entityManager.query(dataQuery);

            const query = "Select transfer_id AS transferId,SUM(transferred_quantity) AS transferedQty from "+appSettings.procure_db+".transferred_items where transferred_quantity > 0 group by transfer_id";
                    let queryResult = await entityManager.query(query);
                    // console.log(queryResult);
            if (response && response.length) {
                for (const transferInfo of response) {
                    // console.log(transferInfo.packingStockTransferId);
                    // console.log(queryResult?.find((rec) => rec.transferId == transferInfo.packingStockTransferId)?.transferedQty)
                //     // const query = "Select SUM(transferred_quantity) AS transferedQty from "+appSettings.procure_db+".transferred_items where transfer_id = "+transferInfo.packingStockTransferId;
                //     // let queryResult = await entityManager.query(query);
                //     // console.log(queryResult);
                //     const plantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: transferInfo.fromPlant });
                //     const fromPlant = plantDetails.status ? plantDetails.data.unitcodeName : "";

                //     const toPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: transferInfo.toPlant });
                //     const toPlant = toPlantDetails.status ? toPlantDetails.data.unitcodeName : "";
                //     transferInfo.fromPlantName = fromPlant;
                //     transferInfo.toPlantName = toPlant;
                    transferInfo.transferedQty = queryResult?.find((rec) => rec.transferId === transferInfo.packingStockTransferId)?.transferedQty;
                }
                return new AllTransferInfo(true, 1111, 'MRN Information Retrieved Successfully', response);
            } else {
                return new AllTransferInfo(false, 9999, 'No MRN Data Found');
            }
        } catch (error) {
            return error;
        }
    }


    async TransferMaterialDetailInfo(req: TransferIdRequest): Promise<AllTransferInfo> {
        try {
            const manager = getManager();
            const response = await this.repo.createQueryBuilder('transfer_material_data')
                .leftJoinAndSelect("transfer_material_data.stockTransferItems", 'items')
                .where(`transfer_material_data.transfer_id = ` + req.packingStockTransferId)
                .getOne();
                console.log(response);
            if (response) {
                const transferData = new TransferMaterialInfo();
                transferData.packingStockTransferId = response.packingStockTransferId
                transferData.status = response.status;
                transferData.fromPlant = response.fromPlant;
                transferData.toPlant = response.toPlant;
                transferData.transferredDate = response.transferredDate;
                transferData.dcNumber = response.dcNumber;
                transferData.mrnNumber = response.mrnNumber;
                transferData.note = response.note;
                transferData.receivedDate = response.receivedDate;
                transferData.transferType = response.transferType;
                transferData.transferMethod = response.transferMethod;
                transferData.createdUser = response.createdUser;
                transferData.updatedUser = response.updatedUser;
                transferData.receivedUser = response.receivedUser;
                transferData.versionFlag = response.versionFlag;
                transferData.isPreparedMaterial = response.isPreparedMaterial;
                const plantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: response.fromPlant });
                const fromPlant = plantDetails.status ? plantDetails.data.unitcodeName : "";

                const toPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: response.toPlant });
                const toPlant = toPlantDetails.status ? toPlantDetails.data.unitcodeName : "";

                // const poNumberData = await this.saleOrderService.getSaleOrderDataForSoId({ saleOrderId: response.saleOrderId });
                // const poNumber = poNumberData.saleOrderId > 0 ? poNumberData.poNumber : "";

                // const indentCodeData = await this.indentformService.getAllIndentdataforindentmaterialId({ indentMaterialPreparationId: response.indentId });
                // console.log("**************");
                // console.log(indentCodeData)

                // const indentCode = indentCodeData.status ? indentCodeData. : "";

                transferData.fromPlantName = fromPlant;
                transferData.toPlantName = toPlant;
                // transferData.poNumber = poNumber;

                const transferItems: TransferItemsDetails[] = [];
                for (const item of response.stockTransferItems) {
                    let checkAllocatedStock = "Select SUM(issued_qty) AS issuedQty from "+appSettings.procure_db+".location_wise_tranfers lwt where transferred_item_id ="+item.packingStockTransferId;
                    let stockData = await manager.query(checkAllocatedStock);
                    console.log("stockData");
                    console.log(stockData);
                    console.log(item.transferredQty);

                    let logId = false;
                    if(Number(stockData[0].issuedQty) >= Number(item.transferredQty) && stockData[0].issuedQty != null){
                        console.log("*********************");
                        logId = true;
                    }
                    else{
                        logId = false;
                    }
                    const transferItem = new TransferItemsDetails();
                    // get item Category, item Sub Category, item, 
                    const itemCategoryReq = new ItemCategoryReq(item.itemCategoryId);
                    const itemCategoryDetails = this.itemCategoryService.getItemCategoryById(itemCategoryReq);
                    if (!itemCategoryDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item Category');
                    }

                    // get item details for item id 
                    const itemReq = new ItemRequest(item.itemId);
                    const itemDetails = this.itemService.getItemForItemId(itemReq);
                    if (!itemDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item');
                    }
                    console.log(itemDetails);
                    // const size = new SizeRequest(item.sizeId);
                    // const sizeDetails = this.sizeService.getSizeDataById(size);
                    // if (!size) {
                    //     throw new ErrorResponse(1111, 'Failed to Get Size');
                    // }

                    // get item sub category details for item sub category id
                    const itemSubCategoryReq = new ItemSubCategoryRequest(item.itemSubCategoryId);
                    const itemSubCategoryDetails = this.subCategoryService.getItemSubCategoryForId(itemSubCategoryReq);
                    if (!itemSubCategoryDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item Category');
                    }

                    await Promise.all([itemCategoryDetails, itemDetails, itemSubCategoryDetails]).then(res => {
                    console.log("res[1]res[1]res[1]res[1]");
                    console.log(res[1].data);


                        const itemCategory = (res[0]) ? res[0] : null;
                        const itemSubCategory = (res[2]) ? res[2] : null;
                        const itemData = (res[1].status) ? res[1].data[0] : null;
                        // const size = (res[2]) ? res[2] : null;
                        transferItem.itemCategory = itemCategory.itemCategory;
                        transferItem.itemCategoryId = itemCategory.itemCategoryId;
                        transferItem.itemSubCategory = itemSubCategory.itemSubCategory;
                        transferItem.itemSubCategoryId = itemSubCategory.itemSubCategoryId;
                        transferItem.item = itemData.itemName;
                        transferItem.itemId = itemData.itemId;
                        transferItem.size = itemData.size;
                        transferItem.sizeId = itemData.sizeId;
                        transferItem.transferredQty = item.transferredQty;
                        transferItem.ipQty = item.ipQty;
                        transferItem.opQty = item.opQty;
                        transferItem.unitPrice = item.unitPrice;
                        transferItem.unitId = response.toPlant;
                        transferItem.brandId = itemData.brand;
                        transferItem.saleOrderId = response.saleOrderId;
                        transferItem.packingStockTransferItemId = item.packingStockTransferId;
                        transferItem.logId = logId;
                        transferItem.allocatedQty = stockData[0].issuedQty
                    })
                    transferItems.push(transferItem);
                }
                transferData.items = transferItems;
                console.log("transferData");
                console.log(transferData);

                return new AllTransferInfo(true, 1111, 'Information Retrieved Successfully', transferData);
            } else {
                return new AllTransferInfo(false, 9999, 'No Data Found');
            }
        } catch (error) {
            return error;
        }
    }

    async getSaleOrderRequiredItemDetails(req: SaleOrderIdRequest): Promise<GetAvailableStockResponse> {
        try {
            console.log(req);
            const manager = getManager();
            let sandhyaBrandtems = await manager.query("SELECT GROUP_CONCAT(i.item_id) AS itemId FROM erpx_dev_masters.items i LEFT JOIN `erpx_dev_masters`.master_brands mb ON mb.master_brand_id = i.brand AND mb.brand_name IN ('Sandhya Aqua','No Brand') WHERE i.brand = mb.master_brand_id");
          let noBrandItems = await manager.query("SELECT GROUP_CONCAT(i.item_id) AS itemId FROM erpx_dev_masters.items i WHERE i.brand is null");
            let trackerQuery = `SELECT soBom.packing_material_id AS id,soBom.sale_order_id as saleOrderId, soBom.item_category_id as itemCategoryId, ic.item_category as itemCategory, ic.item_category_code as itemCategoryCode, soBom.item_sub_category_id as itemSubCategoryId, isc.item_sub_category as itemSubCategory, soBom.item_id as itemId, i.item_name as item, soBom.size as sizeId, soBom.required_qty as requiredQty, `;
            if(req.isPreperationRequired === "yes"){
                trackerQuery = trackerQuery + ` SUM(s.prepared_quantity - s.consumed_quantity) as availableQty , SUM(s.prepared_quantity - s.consumed_quantity) as issuedQty, 0 as unitPrice`;
            }
            else{
                trackerQuery = trackerQuery + ` SUM(s.physical_quantity) as availableQty , SUM(s.physical_quantity) as issuedQty,s.unit_price as unitPrice`;
            }
            trackerQuery = trackerQuery + `  FROM ` + appSettings.sales_db + `.bom_details soBom`
            if(req.isPreperationRequired === "yes"){
                trackerQuery = trackerQuery + ` LEFT JOIN ` + appSettings.procure_db + `.prepared_stock s ON soBom.item_id = s.item_id and s.sale_order_id = ${req.fromSaleOrder}`;
            }
            else if(req.isPreperationRequired === "no"){
                trackerQuery = trackerQuery + ` LEFT JOIN ` + appSettings.procure_db + `.stock s ON s.item_sub_category_id = soBom.item_sub_category_id and (s.item_id IN (`+sandhyaBrandtems[0].itemId+`) OR s.item_id IN (`+noBrandItems[0].itemId+`) OR s.item_id = soBom.item_id) and location_id > 0 and s.saleOrder_id = 0  and s.physical_quantity >0 and s.unit_id=${req.plantId} `;
            }
            trackerQuery = trackerQuery + ` LEFT JOIN ` + appSettings.masters_db + `.item_categories ic ON ic.item_category_id = soBom.item_category_id 
            LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = soBom.item_sub_category_id 
            LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = soBom.item_id 
            where soBom.packing_category IS NOT NULL and soBom.sale_order_id= `+req.fromSaleOrder;
            trackerQuery = trackerQuery + " group by soBom.item_id "
            const saleOrderDto = await manager.query(trackerQuery);

            if (saleOrderDto && saleOrderDto.length > 0) {
                for (const [index, element] of saleOrderDto.entries()) {
                    element.itemCategory = JSON.stringify({ itemCategoryId: element.itemCategoryId, itemCategory: element.itemCategory, itemCategoryCode: element.itemCategoryCode });

                    element.itemSubCategory = JSON.stringify({ itemSubCategoryId: element.itemSubCategoryId, itemSubCategory: element.itemSubCategory });

                    element.item = JSON.stringify({ itemId: element.itemId, itemName: element.item });
                    let query = "Select ";
                    if(req.isPreperationRequired === "yes"){
                        query = query + "prepared_stock_id AS stockId,(prepared_quantity-consumed_quantity) AS availableQty, 0 AS locationId, 0 AS location, ";
                      }
                      else if(req.isPreperationRequired === "no"){
                          query = query + " stock_id AS stockId, physical_quantity AS availableQty, location_id AS locationId, rmrp.rm_rack_code AS location, ";
                      }
                    query = query + `i.item_name AS itemName, 0 AS issuedQty, 0 AS requiredQty, 0 AS isChecked from `;
                    if(req.isPreperationRequired === "yes"){
                        query = query + appSettings.procure_db+`.prepared_stock s`;
                    }
                    else{
                        query = query + appSettings.procure_db+`.stock s `;
                    }
                    if(req.isPreperationRequired === "no"){
                        query = query + ` left join `+appSettings.masters_db+`.items i on i.item_id = s.item_id left join `+appSettings.masters_db+`.rm_rack_position rmrp on rmrp.rm_rack_position_id = s.location_id where s.item_sub_category_id = `+element.itemSubCategoryId+` and s.unit_id = `+req.plantId;
                    }
                    if(req.isPreperationRequired === "yes"){
                      query = query + " left join "+appSettings.masters_db+".items i on i.item_id = s.item_id where s.sale_order_id = "+req.fromSaleOrder + " and (s.prepared_quantity - s.consumed_quantity) > 0 and s.item_id = "+element.itemId;
                    }
                    else if(req.isPreperationRequired === "no"){
                        query = query + " and s.saleorder_id = 0 and s.location_id > 0 and s.physical_quantity > 0";
                    }
                    // if(element.indentAgainst === "SALE ORDER"){
                    //   query = query + " and s.item_id = "+element.itemId;
                    // }
                    // else if(element.indentAgainst === "DUMMY"){
                        if(req.isPreperationRequired === "no"){
                            query = query + " and (s.item_id IN ("+sandhyaBrandtems[0].itemId+") OR s.item_id IN ("+noBrandItems[0].itemId+") OR s.item_id = "+element.itemId+")";
                        }
                    // }
                    query = query + " order by s.created_at DESC";
                    const data = await manager.query(query);
                    let requiredQty = element.requiredQty;
                    let receivedQty = element.issuedQty;
                    console.log("*********"+requiredQty+"*********"+receivedQty);
                    for (const [index1, element1] of data.entries()) {
                      if(element1.availableQty <= requiredQty && requiredQty > 0){
                        data[index1].issuedQty = Number(element1.availableQty) - Number(receivedQty)
                        requiredQty = requiredQty - element1.availableQty;
                      }
                      else if(element1.availableQty > requiredQty && requiredQty > 0){
                        data[index1].issuedQty = Number(requiredQty) - Number(receivedQty);
                        requiredQty = requiredQty - requiredQty;
                      }
                      else{
                        data[index1].issuedQty = 0;
                      }
                      console.log(index1)
                      console.log(element1)
                      data[index1].requiredQty = element.requiredQty
                      data[index1].isChecked = 0;
                      data[index1].indentItemId = element.indentItemId;
        
                    }
                    console.log(data);
                    if(data.length> 0 ){
                      saleOrderDto[index].locationStockInfo = data;
                    }
                    else{
                      saleOrderDto[index].locationStockInfo = {};
                    }
                  }
                  return new GetAvailableStockResponse(true, 1111, "Data retreived sucesssfuly", saleOrderDto)
            } else {
                return new GetAvailableStockResponse(false, 1010, 'No data found');
            }
        } catch (error) {
            return error;
        }
    }

    async getTransferedStockDetails(req: TransferIdRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = "Select rmrp.rm_rack_code AS location, lwt.issued_qty AS quantity,i.item_name AS itemName from "+appSettings.procure_db+".location_wise_tranfers lwt left join "+appSettings.masters_db+".rm_rack_position rmrp on rmrp.rm_rack_position_id = lwt.location left join "+appSettings.masters_db+".items i on i.item_id = lwt.item_id  where transferred_item_id ="+req.packingStockTransferId;
            let response = await manager.query(query);
            console.log(response);
            if(response.length > 0){
                return new CommonResponse(true, 1001, 'Data retrived Successfully. ',response);
            }
            else{
                return new CommonResponse(false, 1010, 'Something went wrong. ');
            }
        } catch (error) {
            return error;
        }
    }
}

